import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Heading from '../../components/Typography/Heading/Heading';
const ComingSoon = () => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: classNames(styles.element, 'd-flex justify-content-center align-items-center') }, { children: _jsx("div", Object.assign({ className: "d-flex align-items-baseline" }, { children: _jsx(Heading, { title: t('coming_soon') }) })) })));
};
export default ComingSoon;
